<template>
    <BaseButton
        class="text-theme-toolbar-icon"
        dusk="create-add-on"
        data-action="create-add-on"
        icon="squares-plus-24px"
        :tooltip="strings.createFromSelection"
        @click="$emit('create-add-on')"
    />
</template>
<script>
'use strict';

import BaseButton from '../../Components/buttons/BaseButton.vue';
import { addOnStrings } from '../../AddOns/addOnStrings.js';
import { mapState } from 'vuex';

export default {
    name: 'AddOnButton',
    components: {
        BaseButton,
    },
    emits: ['create-add-on'],
    computed: {
        ...mapState(['localizations', 'lang']),
        strings() {
            return addOnStrings(this.localizations, this.lang);
        },
    },
};
</script>
